import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useMyAccount } from '../context/MyAccountContext';

const CurrentPinForm: React.FC = () => {
  const {
    option,
    onInputChange,
    formData: formState,
    handleCurrentPinSubmit,
  } = useMyAccount();
  return (
    option === 'currentPin' && (
      <form onSubmit={handleCurrentPinSubmit}>
        <Form.Group as={Row} controlId="currentPin" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>Current PIN</Form.Label>
            <Form.Control
              name="currentPin"
              type="password"
              onChange={onInputChange}
              maxLength={4}
              value={formState.currentPin}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="newPin" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>New PIN</Form.Label>
            <Form.Control
              name="newPin"
              type="password"
              onChange={onInputChange}
              maxLength={4}
              value={formState.newPin}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="confirmPin" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>Confirm new PIN</Form.Label>
            <Form.Control
              name="confirmPin"
              type="password"
              onChange={onInputChange}
              maxLength={4}
              value={formState.confirmPin}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Button type="submit" className="btn btnPrimary btn-long btn-sm">
              Update PIN
            </Button>
          </Col>
        </Form.Group>
      </form>
    )
  );
};

export default CurrentPinForm;
